import React, { useState, useEffect } from "react";

export default function SpaceClicker() {
    const [rockets, setRockets] = useState(0);
    const [perClick, setPerClick] = useState(1);
    const [perSecond, setPerSecond] = useState(0);
    const [timeLeft, setTimeLeft] = useState(30);
    const [gameActive, setGameActive] = useState(false);
    const [upgrades, setUpgrades] = useState({
        autoClicker: { level: 0, cost: 10, production: 1 },
        megaClick: { level: 0, cost: 20, boost: 2 }
    });

    useEffect(() => {
        if (gameActive && timeLeft > 0) {
            const timer = setTimeout(() => setTimeLeft(timeLeft - 1), 1000);
            return () => clearTimeout(timer);
        } else if (timeLeft === 0 && gameActive) {
            setGameActive(false);
        }
    }, [timeLeft, gameActive]);

    useEffect(() => {
        if (gameActive && perSecond > 0) {
            const interval = setInterval(() => {
                setRockets(r => r + perSecond);
            }, 1000);
            return () => clearInterval(interval);
        }
    }, [gameActive, perSecond]);

    const startGame = () => {
        setRockets(0);
        setPerClick(1);
        setPerSecond(0);
        setTimeLeft(30);
        setGameActive(true);
        setUpgrades({
            autoClicker: { level: 0, cost: 10, production: 1 },
            megaClick: { level: 0, cost: 20, boost: 2 }
        });
    };

    const handleClick = () => {
        if (gameActive) {
            setRockets(rockets + perClick);
        }
    };

    const buyAutoClicker = () => {
        if (rockets >= upgrades.autoClicker.cost) {
            setRockets(rockets - upgrades.autoClicker.cost);
            setPerSecond(perSecond + upgrades.autoClicker.production);
            setUpgrades({
                ...upgrades,
                autoClicker: {
                    ...upgrades.autoClicker,
                    level: upgrades.autoClicker.level + 1,
                    cost: Math.floor(upgrades.autoClicker.cost * 1.5)
                }
            });
        }
    };

    const buyMegaClick = () => {
        if (rockets >= upgrades.megaClick.cost) {
            setRockets(rockets - upgrades.megaClick.cost);
            setPerClick(perClick + upgrades.megaClick.boost);
            setUpgrades({
                ...upgrades,
                megaClick: {
                    ...upgrades.megaClick,
                    level: upgrades.megaClick.level + 1,
                    cost: Math.floor(upgrades.megaClick.cost * 1.8)
                }
            });
        }
    };

    if (!gameActive && timeLeft > 0) {
        return (
            <div style={{
                textAlign: "center",
                padding: "1rem",
                color: "#e5e7eb",
                background: "rgba(255,255,255,0.05)",
                borderRadius: "1rem",
                boxShadow: "0 0 25px rgba(0,255,200,0.15)"
            }}>
                <h4 style={{color:"#facc15", marginBottom:"0.5rem"}}>
                    <i className="fas fa-space-shuttle" style={{marginRight:"6px"}}></i> Space Clicker
                </h4>
                <p style={{fontSize:"0.85rem", marginBottom:"1rem"}}>
                    Lancia razzi nello spazio! Clicca e compra upgrade!
                </p>
                <button
                    onClick={startGame}
                    style={{
                        background:"linear-gradient(135deg,#facc15,#ca8a04)",
                        border:"none",
                        color:"#000",
                        fontWeight:"700",
                        padding:"0.6rem 1.2rem",
                        borderRadius:"0.5rem",
                        cursor:"pointer"
                    }}
                >
                    <i className="fas fa-play" style={{marginRight:"6px"}}></i> Inizia
                </button>
            </div>
        );
    }

    if (timeLeft === 0) {
        return (
            <div style={{
                textAlign: "center",
                padding: "1.5rem",
                color: "#e5e7eb",
                background: "rgba(255,255,255,0.05)",
                borderRadius: "1rem",
                boxShadow: "0 0 25px rgba(0,255,200,0.15)"
            }}>
                <h4 style={{color:"#facc15", marginBottom:"1rem"}}>
                    <i className="fas fa-rocket" style={{marginRight:"6px"}}></i> Missione Completata!
                </h4>
                <p style={{fontSize:"2rem", fontWeight:"700", color:"#22c55e", marginBottom:"1rem"}}>
                    🚀 {rockets}
                </p>
                <p style={{fontSize:"0.9rem", marginBottom:"1.5rem"}}>
                    {rockets >= 200 && "🎉 Comandante spaziale!"}
                    {rockets >= 100 && rockets < 200 && "👨‍🚀 Astronauta esperto!"}
                    {rockets >= 50 && rockets < 100 && "🛸 Buon pilota!"}
                    {rockets < 50 && "🌟 Cadetto spaziale!"}
                </p>
                <button
                    onClick={startGame}
                    style={{
                        background:"linear-gradient(135deg,#16a34a,#065f46)",
                        border:"none",
                        color:"#fff",
                        fontWeight:"700",
                        padding:"0.6rem 1.2rem",
                        borderRadius:"0.5rem",
                        cursor:"pointer"
                    }}
                >
                    <i className="fas fa-redo" style={{marginRight:"6px"}}></i> Nuova Missione
                </button>
            </div>
        );
    }

    return (
        <div style={{
            textAlign: "center",
            padding: "1.5rem",
            color: "#e5e7eb",
            background: "rgba(255,255,255,0.05)",
            borderRadius: "1rem",
            boxShadow: "0 0 25px rgba(0,255,200,0.15)"
        }}>
            <div style={{
                display:"flex",
                justifyContent:"space-between",
                marginBottom:"1rem",
                fontSize:"0.85rem"
            }}>
                <span style={{color:"#94a3b8"}}>⏱️ {timeLeft}s</span>
                <span style={{color:"#facc15", fontWeight:"700"}}>
                    +{perSecond}/s
                </span>
            </div>

            <div style={{
                fontSize:"2.5rem",
                fontWeight:"700",
                color:"#00ffa3",
                marginBottom:"1rem"
            }}>
                🚀 {rockets}
            </div>

            <button
                onClick={handleClick}
                style={{
                    width:"100%",
                    padding:"1.5rem",
                    borderRadius:"1rem",
                    border:"none",
                    background:"linear-gradient(135deg,#3b82f6,#1e40af)",
                    color:"#fff",
                    fontSize:"1.5rem",
                    fontWeight:"700",
                    cursor:"pointer",
                    marginBottom:"1rem",
                    transition:"all 0.2s ease"
                }}
                onMouseDown={(e) => e.currentTarget.style.transform = "scale(0.95)"}
                onMouseUp={(e) => e.currentTarget.style.transform = "scale(1)"}
            >
                🚀 LANCIA! (+{perClick})
            </button>

            <div style={{
                display:"flex",
                flexDirection:"column",
                gap:"0.5rem"
            }}>
                <button
                    onClick={buyAutoClicker}
                    disabled={rockets < upgrades.autoClicker.cost}
                    style={{
                        padding:"0.8rem",
                        borderRadius:"0.5rem",
                        border:"1px solid rgba(255,255,255,0.1)",
                        background: rockets >= upgrades.autoClicker.cost
                            ? "rgba(34,197,94,0.2)"
                            : "rgba(255,255,255,0.05)",
                        color: rockets >= upgrades.autoClicker.cost ? "#22c55e" : "#64748b",
                        cursor: rockets >= upgrades.autoClicker.cost ? "pointer" : "not-allowed",
                        fontSize:"0.8rem",
                        textAlign:"left"
                    }}
                >
                    <div style={{fontWeight:"700", marginBottom:"2px"}}>
                        🤖 Auto-Clicker Lv.{upgrades.autoClicker.level}
                    </div>
                    <div style={{fontSize:"0.75rem"}}>
                        +{upgrades.autoClicker.production}/s | Costo: {upgrades.autoClicker.cost} 🚀
                    </div>
                </button>

                <button
                    onClick={buyMegaClick}
                    disabled={rockets < upgrades.megaClick.cost}
                    style={{
                        padding:"0.8rem",
                        borderRadius:"0.5rem",
                        border:"1px solid rgba(255,255,255,0.1)",
                        background: rockets >= upgrades.megaClick.cost
                            ? "rgba(251,191,36,0.2)"
                            : "rgba(255,255,255,0.05)",
                        color: rockets >= upgrades.megaClick.cost ? "#facc15" : "#64748b",
                        cursor: rockets >= upgrades.megaClick.cost ? "pointer" : "not-allowed",
                        fontSize:"0.8rem",
                        textAlign:"left"
                    }}
                >
                    <div style={{fontWeight:"700", marginBottom:"2px"}}>
                        💪 Mega-Click Lv.{upgrades.megaClick.level}
                    </div>
                    <div style={{fontSize:"0.75rem"}}>
                        +{upgrades.megaClick.boost} per click | Costo: {upgrades.megaClick.cost} 🚀
                    </div>
                </button>
            </div>
        </div>
    );
}